import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=d21a9130&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=d21a9130&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a9130",
  null
  
)

/* custom blocks */
import block0 from "./SignUp.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d21a9130')) {
      api.createRecord('d21a9130', component.options)
    } else {
      api.reload('d21a9130', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=d21a9130&scoped=true&", function () {
      api.rerender('d21a9130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SignUp.vue"
export default component.exports